import React from 'react'

import Page from './Page'
import Form from '../components/form/Form';
import NavBar from '../components/nav/NavBar'
import Footer from "../components/nav/Footer";

export default class FormPage extends Page
{
    /**
     * The css class for the page container
     *
     * @var {String}
     */
    static BGClass = '';

    /**
     * The max width in pixels for the form container
     *
     * @var {Integer}
     */
    static MaxWidth = 600;

    /**
     * Show asterisk next to required fields
     */
    static ShowRequired = false;
    /**
     * The config for the optional navbar
     *
     * @var {Object}
     */
    static NavBar = false;
    /**
     * The config for the optional footer
     *
     * @var {Object}
     */
    static ShowFooter = false;

    /**
     * @returns {Object}
     */
    navBar()
    {
        return this.constructor.NavBar;
    }

	/**
     * The title shown on the form
     *
     * @var {String | Array[String]}
     */
	static FormTitle;

    /**
     * @returns {String | Array}
     */
    formTitle()
    {
        return TB.tryTrans(
            this.constructor.FormTitle
        );
    }

	/**
     * The subtitle shown on the form
     *
     * @var {String}
     */
	static FormSubtitle;

    /**
     * @returns {String}
     */
    formSubtitle()
    {
        return TB.tryTrans(
            this.constructor.FormSubtitle
        );
    }

	/**
     * The submit button options for the form
     * Defaults to {title: 'Submit', show: true}
     *
     * @var {String | Boolean | Object}
     */
	static FormSubmit;

    /**
     * @returns {String | Boolean | Object}
     */
    formSubmit()
    {
        let submitTitle = this.constructor.FormSubmit;
        if (TB.isObject(submitTitle)) {
            submitTitle = submitTitle.title;
        }
        if (!submitTitle) {
            return this.constructor.FormSubmit;
        }

        let translated = TB.tryTrans(
            submitTitle
        );

        submitTitle = translated ? translated : submitTitle;

        let submit = this.constructor.FormSubmit;
        if (TB.isString(submit)) {
            return submitTitle;
        }

        submit.title = submitTitle;

        return submit;
    }

	/**
     * [Optional] The api endpoint path that the form should send a post request to
     *
     * @var {String}
     */
	static FormPost;

    /**
     * @returns {String}
     */
    formPost()
    {
        return this.constructor.FormPost;
    }

	/**
     * The fields mapping for the form {field1: {type: 'text'}, field2: {type: 'email'}}
     *
     * @var {Object | Array[Object]}
     */
    static FormFields = {
    	//
    };

    /**
     * @returns {Object | Array}
     */
    formFields()
    {
        return this.transFormFields(
            this.constructor.FormFields
        );
    }

    /**
     * @returns {Object | Array}
     */
    transFormFields(fields)
    {
        if (TB.isArray(fields)) {
            return this.transFormFieldGroups(
                fields
            );
        }

        let transFields = {};
        for (let name in fields) {
            let field = fields[name];
            if (field.label) {
                field.label = TB.tryTrans(field.label);
            }
            transFields[name] = field;
        }

        return transFields;
    }

    /**
     * @returns {Object | Array}
     */
    transFormFieldGroups(fieldGroups)
    {
        let transFieldGroups = [];
        for (let group of fieldGroups) {
            if (group.fields) {
                group.fields = this.transFormFields(
                    group.fields
                );
            }
            transFieldGroups.push(group);
        }

        return transFieldGroups;
    }

    /**
     * The links mapping for the form [{title: 'Some Link', path: '/some-path', columns: 12}]
     *
     * @var {Array[Object]}
     */
    static FormLinks = [
       	//
   	];

    /**
     * @returns {Array}
     */
    formLinks()
    {
        let links = this.constructor.FormLinks;
        let transLinks = [];
        for (let link of links) {
            if (link.title) {
                link.title = TB.tryTrans(link.title);
            }
            transLinks.push(link);
        }

        return transLinks;
    }

    /**
     * Whether or not an alert should show if the user tries to navigate to another page or close the browser
     *
     * @var {Boolean}
     */
    static ShowsUnloadWarning = true;

    /**
     * @returns {Boolean}
     */
    showsUnloadWarning()
    {
        return this.constructor.ShowsUnloadWarning;
    }

    formRef = null;

   	/**
     * [Constructor]
     *
     * @param {Object} props
     * @returns {FormPage}
     */
    constructor(props,context)
    {
		super(props, context);
        this.formRef = React.createRef();

		this.state = {
			...this.state,
			isDisabled: false,
		};
	}

	/**
     * [Note]
     *
     * @returns void
     */
	componentDidMount() {
		super.componentDidMount();

		//
	}

	/**
     * Custom Form Component Props
     *
     * @returns {Object}
     */
    formProps() {
        return {}
    }

	/**
     * Overridable method for mapping form input data to form submit models
     *
     * @param {Object} model
     * @returns {Object}
     */
	mapping(model)
	{
		return model;
	}

	/**
     * Overridable method for handling form submit button clicks when form is valid
     *
     * @param {Object} model
     * @returns void
     */
	onSubmit(model)
	{
		console.log(
			`${this.constructor.formTitle} Form @ onSubmit`, { ...model }
		);
	}

	/**
     * Overridable method for handling successful responses returned by TB Request
     *
     * @param {Object} responseData
     * @returns void
     */
	onSuccess(responseData)
	{
		// TB.log().object(
		// 	`${this.constructor.formTitle} Form @ onSuccess`, { ...responseData }
		// );
	}

	/**
     * Overridable method for handling any AND all response errors returned by TB Request
     *
     * @param {Error} error
     * @returns void
     */
	onError(error)
	{
		// TB.log().object(
		// 	`${this.constructor.formTitle} Form @ onError`, { error }
		// );
	}

	/**
     * Overridable method for handling response errors that weren't already handled by TB Request
     *
     * @param {Error} error
     * @returns void
     */
	onUnhandledError(error)
	{
        console.log('onUnhandledError', error)
		// TB.log().object(
		// 	`${this.constructor.formTitle} Form @ onUnhandledError`, { error }
		// );

		this.showErrorAlert();
	}

	/**
     * Show general server error response feedback as modal alert
     *
     * @returns void
     */
	showErrorAlert()
	{
		TB.alert(
			'error',
			'Oops!',
			'Sorry, something went wrong. Please try again'
		);
	}

	/**
     * Render the form
     *
     * @returns {Form}
     */
	render()
	{
        const navBarProps = this.navBar();

        let ShowFooter = this.constructor.ShowFooter;
		return (
            // <div className={TB.mapClass("container-fluid px-4", {
            (<div className={TB.mapClass("container-fluid", {
                    "pb-1": ShowFooter
            })}>
                {TB.isObject(navBarProps) && <NavBar {...navBarProps}/>}
                {this.renderFormView()}
                {ShowFooter && <Footer/>}
            </div>)
        );
	}

    /**
     * Overridable method for rendering any form child elements
     *
     * @returns {Component}
     */
    renderFormView()
    {
        let panelContainerStyles = {};

        panelContainerStyles.maxWidth = this.constructor.MaxWidth;

        return (
            <div className={'form-container'} style={{paddingBottom: '50px'}}>
                <div style={panelContainerStyles}>
                    {this.renderForm()}
                </div>
            </div>
        );
    }



    /**
     * Overridable method for rendering any form child elements
     *
     * @returns {JSX.Element}
     */
    renderForm()
    {
        return (
            <Form
                {...this.formProps()}
                ref={this.formRef}
                title={this.formTitle()}
                subtitle={this.formSubtitle()}
                className={this.constructor.BGClass + ' default-form '}
                submitButton={this.formSubmit()}
                post={this.formPost()}
                onSubmit={this.onSubmit.bind(this)}
                model={this.state.model}
                showRequired={this.constructor.ShowRequired}
                onSuccess={this.onSuccess.bind(this)}
                onError={this.onError.bind(this)}
                onUnhandledError={this.onUnhandledError.bind(this)}
                onChange={model => this.setState({model: this.mapping({...model})})}
                mapping={this.mapping.bind(this)}
                links={this.formLinks()}
                fields={this.formFields()}
                isDisabled={this.state.isDisabled}
                showUnloadWarning={this.showsUnloadWarning()}
                validateBeforeSubmit={this.validateBeforeSubmit}
            >
                {this.renderFormChildren()}
            </Form>
        );
    }

    /**
     * Overridable method for rendering any form child elements
     *
     * @returns {Component}
     */
    renderFormChildren()
    {
        return (
            <div/>
        );
    }
}